import { Matrix } from "../../maths/Matrix";
import { Pool } from "../../utils/Pool";
const className = "TransformCmd";
export class TransformCmd {
    static create(matrix, pivotX, pivotY) {
        var cmd = Pool.getItemByClass(className, TransformCmd);
        cmd.matrix = matrix;
        cmd.pivotX = pivotX;
        cmd.pivotY = pivotY;
        return cmd;
    }
    recover() {
        this.matrix = null;
        Pool.recover(className, this);
    }
    run(runner, gx, gy) {
        runner._transform(this.matrix, this.pivotX + gx, this.pivotY + gy);
    }
    getBounds(assembler) {
        tempMatrix.identity();
        tempMatrix.translate(-this.pivotX, -this.pivotY);
        tempMatrix.concat(this.matrix);
        tempMatrix.translate(this.pivotX, this.pivotY);
        assembler.concatMatrix(tempMatrix);
    }
    get cmdID() {
        return TransformCmd.ID;
    }
}
TransformCmd.ID = className;
const tempMatrix = new Matrix();
